<template>
    <div class="center">
      <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
            Editar registro
          </h4>
        </template>
        <div class="con-form">
          <vs-row class="d-flex">
              <vs-col sm="12" lg="6">
                  <form autocomplete="off">
                    <label class="labelInput" for="nombre">Nombre</label>
                    <vs-input class="pt-0" id="nombre" v-model="nombre" placeholder="Nombre">
                        <template #message-danger v-if="errorFields.includes('nombre')">
                                Requerido
                            </template>
                    </vs-input>
                  </form>
              </vs-col>
              <vs-col sm="12" lg="6">
                  <form autocomplete="off">
                    <label class="labelInput" for="nombre">Tipo</label>
                    <vs-select class="pt-0" placeholder="Tipo" v-model="tipo">
                        <vs-option label="Alfanúmerica" value="1">
                            Alfanúmerica
                        </vs-option>
                        <vs-option label="Númerica" value="2">
                            Númerica
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('tipo')">
                            Requerido
                        </template>
                    </vs-select>
                  </form>
              </vs-col>
              <vs-col v-if="tipo === '1'">
                  <vs-row>
                    <vs-col class="px-3">
                        <p><strong>Dar enter después de escribir cada valor alfanumérico.</strong></p>
                    </vs-col>
                    <vs-col sm="12" lg="5" class="px-3">       
                        <label class="mb-0" style="font-size:12px" for="valor_minimo">Lista de valores alfanuméricos no acreditables</label>                   
                        <md-chips class="my-0" v-model="valores_alfanumericos" md-placeholder="Valores alfanuméricos no acreditables">
                        </md-chips>
                        <span v-if="errorFields.includes('valores_alfanumericos')" class="vs-input__message vs-input__message--danger v-enter-to" style="height: 21px;">Requerido</span>
                    </vs-col>
                    <vs-col sm="12" lg="7" class="px-3">    
                        <label class="mb-0" style="font-size:12px" for="valor_minimo">Lista de valores alfanuméricos acreditables</label>                 
                        <md-chips class="my-0" v-model="valores_alfanumericos_acreditables" md-placeholder="Valores alfanuméricos acreditables">
                        </md-chips>
                        <span v-if="errorFields.includes('valores_alfanumericos_acreditables')" class="vs-input__message vs-input__message--danger v-enter-to" style="height: 21px;">Requerido</span>
                    </vs-col>
                  </vs-row>
              </vs-col>
              <vs-col v-if="tipo === '2'">
                  <vs-row>
                    <vs-col sm="12" lg="6">
                        <form autocomplete="off">
                            <label class="labelInput" for="valor_minimo">Valor mínimo</label>
                            <vs-input
                            class="pt-0"
                            type="number"
                            v-model="valor_minimo"
                            >
                                <template #message-danger v-if="errorFields.includes('valor_minimo')">
                                    Requerido
                                </template>
                            </vs-input>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="6">
                        <form autocomplete="off">
                            <label class="labelInput" for="valor_maximo">Valor máximo</label>
                            <vs-input
                            class="pt-0"
                            type="number"
                            v-model="valor_maximo"
                            >
                                <template #message-danger v-if="errorFields.includes('valor_maximo')">
                                    Requerido
                                </template>
                            </vs-input>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="6">
                        <form autocomplete="off">
                            <label class="labelInput" for="valor_acreditable">Tipo entero o decimal</label>
                            <vs-select class="pt-0" placeholder="Tipo" v-model="tipo_numerico">
                                <vs-option label="Entero" value="entero">
                                    Entero
                                </vs-option>
                                <vs-option label="Decimal" value="decimal">
                                    Decimal
                                </vs-option>
                                <template #message-danger v-if="errorFields.includes('tipo_numerico')">
                                    Requerido
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="6" v-if="tipo_numerico === 'decimal'">
                        <form autocomplete="off">
                            <label class="labelInput" for="valor_acreditable">Número de decimales</label>
                            <vs-input
                            class="pt-0"
                            type="number"
                            v-model="decimales"
                            >
                                <template #message-danger v-if="errorFields.includes('decimales')">
                                    Requerido
                                </template>
                            </vs-input>
                        </form>
                    </vs-col>
                  </vs-row>
              </vs-col>
                <vs-col sm="12" class="vs-input-parent">
                    <form autocomplete="off">
                        <textarea class="vs-input-parent" v-model="descripcion" placeholder="Descripción"></textarea>
                    </form>
                </vs-col>
          </vs-row>
        </div>

        <template #footer>
          <div class="footer-dialog">
            <vs-button class="ml-auto" block @click="getActualizar()" style="width: 30%;">
              Guardar
            </vs-button>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>

<script>
import academico from '../../../../../api/requests/academico'
export default {
    props:[
      'value',
      'info',
    ],
    data(){
        return{
            active: false,
            nombre: '',
            tipo: '',
            valor_minimo: '',
            valor_maximo: '',
            valor_acreditable: '',
            tipo_numerico: '',
            descripcion: '',
            decimales: '',
            valores_alfanumericos: [],
            valores_alfanumericos_acreditables: [],
            errorFields: [],
        }
    },
    methods:{
      getInfo(){
        this.nombre = this.info.nombre
        this.valor_minimo = this.info.valor_minimo
        this.valor_maximo = this.info.valor_maximo
        this.descripcion = this.info.descripcion
        this.decimales = this.info.decimales
        if(this.info.tipo_escala === 'numerica'){
          this.tipo = '2'
        }else if(this.info.tipo_escala === 'alfanumerica'){
          this.valores_alfanumericos_acreditables = this.valores_alfanumericos_acreditables != null || this.valores_alfanumericos_acreditables != '' ? this.info.valores_alfanumericos_acreditables : ''
          this.valores_alfanumericos = this.info.valores_alfanumericos != null || this.info.valores_alfanumericos != '' ? this.info.valores_alfanumericos : ''
          this.tipo = '1'
        }
        if(this.info.tipo_numerico === 'decimal'){
          this.tipo_numerico = 'decimal'
        }else if(this.info.tipo_numerico === 'entero'){
          this.tipo_numerico = 'entero'
        }
      },
        sanityForm () {
            this.errorFields = []
            if (!this.nombre) {
                this.errorFields.push('nombre')
            }
            if (!this.tipo) {
                this.errorFields.push('tipo')
            }
            if(this.tipo == '2'){
                if (!this.valor_minimo) {
                    this.errorFields.push('valor_minimo')
                }
                if (!this.valor_maximo) {
                    this.errorFields.push('valor_maximo')
                }
                if (!this.tipo_numerico) {
                    this.errorFields.push('tipo_numerico')
                }
                if(this.tipo_numerico == 'decimal'){
                    if (!this.decimales) {
                        this.errorFields.push('decimales')
                    }
                }
            }else{
                if (!this.valores_alfanumericos.length) {
                    this.errorFields.push('valores_alfanumericos')
                }
                if (!this.valores_alfanumericos_acreditables.length) {
                    this.errorFields.push('valores_alfanumericos_acreditables')
                }
            }
            if (!this.errorFields.length){
                return true
            } else {
                return false
            }
        },
      async getActualizar(){
        if(this.sanityForm()){
            try {
                const formData = new FormData();
                formData.append('nombre', this.nombre)
                if(this.tipo === '1'){
                    formData.append('tipo_escala', 'alfanumerica')
                    formData.append('valores_alfanumericos', this.valores_alfanumericos)
                    formData.append('valores_alfanumericos_acreditables', this.valores_alfanumericos_acreditables)
                    formData.append('valor_minimo', '')
                    formData.append('valor_maximo', '')
                    formData.append('tipo_numerico', '')
                    if(this.tipo_numerico === 'decimal'){
                      formData.append('decimales', '')
                    }else if(this.tipo_numerico === 'entero'){
                      formData.append('decimales', '')
                    }
                } else if(this.tipo === '2'){
                    formData.append('tipo_escala', 'numerica')
                    formData.append('valor_minimo', this.valor_minimo)
                    formData.append('valor_maximo', this.valor_maximo)
                    formData.append('tipo_numerico', this.tipo_numerico)
                    if(this.tipo_numerico === 'decimal'){
                      formData.append('decimales', this.decimales)
                    }else if(this.tipo_numerico === 'entero'){
                      formData.append('decimales', '')
                    }
                    formData.append('valores_alfanumericos', [])
                    formData.append('valores_alfanumericos_acreditables', [])
                }
                formData.append('descripcion', this.descripcion)
                const { data: response } = await academico.getActualizar(this.info.id, formData)
                this.$vs.notification({
                    progress: 'auto',                           
                    color: 'success',
                    position: null,
                    title: 'El registro se ha modificado con éxito'
                })
                this.active = false
                this.$emit('refreshTable')
            }
            catch{
                
            }
        }
      }
    },
    watch:{
      value (val) {
          this.active = val
      },
      async active (val) {
          if (!val){
              this.$emit('input', val);
          }
      },
      info(){
        this.getInfo()
      },
      tipo_numerico(){
        if(this.tipo_numerico === 'entero'){
          this.decimales = this.info.decimales
        }
      }
    }
}
</script>
